import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { FormInput_text } from "components";

import { isArrayNotEmpty, isFunction, isNullUndefined, isNumberValid } from 'functions';

import "assets/scss/components/tables/pagination.scss";



export function Pagination(props) {
    const { 
		className, componentId,
		totalPages, totalRecords, pageRange, currentPage, currentPageSize 
	} = props;

	// Validate Props
    let totalPages_validated = isNumberValid(totalPages)? totalPages:0;
	let pageRange_validated = isNumberValid(pageRange)? pageRange:0;
	let currentPage_validated = isNumberValid(currentPage)? currentPage:0;

	let isBackDisabled = (currentPage_validated === 0);
	let isNextDisabled = (currentPage_validated === (totalPages - 1));
    let pageRange_first = Math.floor(currentPage_validated/pageRange_validated) * pageRange_validated; 
	let pageRange_last = pageRange_first + 3; 
	let lastPageNumber = totalPages_validated - 1;
    if (lastPageNumber < pageRange_last) pageRange_last = lastPageNumber;
	
	// Page Range
	let pageRangeDisplay = [];
	for (let i = pageRange_first; i <= pageRange_last; i++) {
		let isCurrentPage = (currentPage_validated === i);
		
		pageRangeDisplay.push(
			<div key={i} className={"component-pagination-pageRange-individual-wrapper d-flex justify-content-center "}>
				<div key={i} 
					className={"component-pagination-pageRange-individual " +
								(isCurrentPage? "component-pagination-pagerange-individual_highlight ":"")} 
					onClick={() => { handlePageChange(i); }}>
					{i + 1}
				</div>
			</div>
		);
	}

	function handlePageChange(pageNo, pageSize) {
		let pageSize_formatted = pageSize;
		if (isNullUndefined(pageSize)) 
			pageSize_formatted = currentPageSize;

		if (isNumberValid(pageNo) &&
			(pageNo >= 0) &&
			(pageNo <= lastPageNumber)) {

			if (isFunction(props.onPageChange))
				props.onPageChange(pageNo, pageSize_formatted);
		}
	}

	let pageSizeLimits = [];
	if (totalRecords > 0) {
		if (totalRecords < 10) {
			pageSizeLimits.push(10);
		}
		else if (totalRecords < 25) {
			pageSizeLimits.push(10);
			pageSizeLimits.push(25);
		}
		else if (totalRecords < 50) {
			pageSizeLimits.push(10);
			pageSizeLimits.push(25);
			pageSizeLimits.push(50);
		}
		else {
			pageSizeLimits.push(10);
			pageSizeLimits.push(25);
			pageSizeLimits.push(50);
			pageSizeLimits.push(100);
		}
	}
	
	let pageSizesDisplay = pageSizeLimits.map((size, idx) => {
		return (
			<span key={idx} className={"page-size-options__page-size " +
					((currentPageSize === size)? "page-size-options__page-size_selected ":"")}
				onClick={() => handlePageChange(0, size)}		
			>
				{size}
			</span>
		)
	});

	let isLeftSectionVisible = isArrayNotEmpty(pageSizesDisplay) && (currentPageSize < totalRecords);
	let isRightSectionVisible = !((pageRange_validated === 0) || (totalPages_validated <= 1));
	let isPaginationVisible = isLeftSectionVisible || isRightSectionVisible;
 
    return (
        <div id={componentId} 
			className={"component-pagination " +
			(className? className + " ":"") +
			(isPaginationVisible? "":"d-none ")}>

			<div className={"d-flex align-items-center justify-content-between "}>
				{/* Left Section */}
				<div className={"component-pagination__left-section"}>
					{/* Page Sizes */}
					<div className={"left-section__page-size-options text-center"}>
						{pageSizesDisplay}
					</div>
				</div>

				{/* Right Section */}
				{isRightSectionVisible? (
					<div className={"component-pagination__right-section d-md-flex align-items-center"}>
						{/* Page Jump */}
						<div className="component-pagination-pageJump d-flex align-items-center pt-3 pt-md-0 ">
							<div className={"component-pagination-pageJump-label"}>Go to:</div>
							<FormInput_text
								customInputClassName={"component-pagination-pageJump-input text-center"}
								
								propagateValueBlur={(value) => { handlePageChange(value - 1); }}
								isInputBlurHandlingRequired

								handleInputKeyDown={(e, value) => {
									let keyCode = e.keyCode;

									// on Enter
									if ((keyCode === 13))
										handlePageChange(value - 1);
								}}
								isInputKeyDownHandlingRequired

								isInputDigitOnly isConvertedToNumber
								isInputOptional isMarginBtmOptional
							/>
						</div>

						<div className={"pt-3 pt-md-0 d-flex align-items-center"}>
							{/* Back */}
							<FontAwesomeIcon
								className={"component-pagination-back " +
											(isBackDisabled? "component-pagination-back_disabled ":"")}
								icon={faChevronLeft}

								onClick={() => { handlePageChange(currentPage_validated - 1); }}
							/>

							{/* First Page Navigation */}
							{(pageRange_first > 0)? (
								<div className={"component-pagination-firstPageNav d-flex align-items-center "}>
									<div
										className={"component-pagination-firstPageNav-digit"}
										onClick={() => { handlePageChange(0); }} 
									>
										1
									</div>
									<div className={"component-pagination-firstPageNav-dots"}>...</div>
								</div>
							):""}

							{/* Page Range */}
							<div className="component-pagination-pageRange d-flex align-items-center ">
								{pageRangeDisplay}
							</div>


							{/* Last Page Navigation */}
							{(pageRange_last < lastPageNumber)? (
								<div className={"component-pagination-lastPageNav d-flex align-items-center "}>
									<div className={"component-pagination-lastPageNav-dots"}>...</div>
									<div
										className={"component-pagination-lastPageNav-number"}
										onClick={() => { handlePageChange(lastPageNumber); }} 
									>
										{totalPages_validated}
									</div>
								</div>
							):""}

							{/* Next */}
							<FontAwesomeIcon
								className={"component-pagination-next " +
											(isNextDisabled? "component-pagination-next_disabled ":"")}
								icon={faChevronRight}
								onClick={() => { handlePageChange(currentPage_validated + 1); }}
							/>
						</div>
					</div>
				):""}
			</div>
        </div>
    );
}